<template>
    <div>
        <AddCompanyDialog ref="AddCompanyDialogRef" :parkId="parkId" :dialogTitle="addCompanyDialogTitle"
            @load="load" />
        <ViewUpdateCompanyDialog ref="ViewUpdateCompanyDialogRef" :dialogTitle="viewUpdateCompanyDialogTitle"
            :type="type" :companyId="companyId" @load="load" />
        <el-dialog title="企业管理" :visible.sync="dialogVisible" width="900px" @close="handleClose"
            :close-on-click-modal="false">
            <template>
                <el-table :data="tableData" style="width: 100%" max-height="500px" v-loading="loading">
                    <el-table-column align="center" label="企业名称">
                        <template slot-scope="scope">
                            <span>{{ scope.row.companyName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="编辑时间" width="150">
                        <template slot-scope="scope">
                            <span>{{ scope.row.updateTime }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="操作人" width="150">
                        <template slot-scope="scope">
                            <span>{{ scope.row.person }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="操作" width="250">
                        <template slot-scope="scope">
                            <el-button size="mini" type="info" @click="handleView(scope.row)">查看</el-button>
                            <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                            <el-button size="mini" type="danger" @click="handleDel(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>

            <!-- 底部按钮 -->
            <template #footer>
                <span class="dialog-footer">
                    <el-button type="primary" @click="openAddCompany">新增企业</el-button>
                    <el-button type="primary" @click="handleClose">关闭</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { findCompanyListByParkId, delCompanyFromPark } from "@/api/projectManage";
import AddCompanyDialog from "./AddCompanyDialog.vue"
import ViewUpdateCompanyDialog from "./ViewUpdateCompanyDialog.vue";

export default {
    name: 'CompanyManagementDialog',
    components: {
        AddCompanyDialog, ViewUpdateCompanyDialog,
    },
    props: {
        //园区id
        parkId: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            dialogVisible: false,
            loading: false,
            tableData: [],

            addCompanyDialogTitle: '新增企业',

            viewUpdateCompanyDialogTitle: '',
            type: '',
            companyId: '',
        };
    },
    watch: {
        dialogVisible(val) {
            if (val) {
                this.load()
            }
        }
    },
    methods: {


        //编辑企业content信息
        handleEdit(row) {
            this.$refs.ViewUpdateCompanyDialogRef.dialogVisible = true;
            this.viewUpdateCompanyDialogTitle = '更新企业信息';
            this.type = 'update';
            this.companyId = row.companyId
        },

        //查看企业信息
        handleView(row) {
            this.$refs.ViewUpdateCompanyDialogRef.dialogVisible = true;
            this.viewUpdateCompanyDialogTitle = '企业详情';
            this.type = 'view';
            this.companyId = row.companyId
        },

        //打开注册或新建公司dialog
        openAddCompany() {
            this.$refs.AddCompanyDialogRef.dialogVisible = true;
        },

        //点击删除
        handleDel(row) {
            this.$confirm("此操作将永久删除, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(async () => {
                let res = await delCompanyFromPark({ parkId: this.parkId, companyId: row.companyId });
                if (res.success) {
                    this.$message({
                        type: "success",
                        message: "删除成功",
                    });
                    this.load();
                }
            }).catch(() => {
            });
        },

        // 关闭弹窗回调
        handleClose() {
            this.dialogVisible = false;
        },

        //查询
        async load() {
            try {
                this.loading = true;
                const res = await findCompanyListByParkId({ parkId: this.parkId });

                if (res.success) {
                    console.log('res.data---------', res.data)
                    this.tableData = res.data || [];
                } else {
                    this.$message.error("查询失败");
                }
            } catch (error) {
                console.error('加载数据出错:', error);
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>
